import { useNavigate } from "react-router-dom";
import { useFetch } from "../../../utils/hooks/useFetch"
import { clearCurrentSession, getCurrentSessionPages, getLoggedInUserInfo,getChangePasswordServiceConfig, getLoginServiceRequestDetails, saveloginInfoToLocal, getResetPasswordServiceConfig, getForgotPasswordRequestConfig } from "../../../utils/services/auth";
import { getResourcePayload } from "../../../utils/services/account";
import { useDispatch } from "react-redux";
import { userActions } from "../../../store/actions";
import { SITE_LINKS_SCHEMA } from "../../../router/navlinks";
import { useCallback } from "react";
import { DATE_TIME_FORMAT } from "../../../utils/constants";
import moment from "moment";
export const useAuth = () => {
    const { isLoading, isError, performAction } = useFetch();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginUser = async (email, password) => {
        try {
            const { url, options } = getLoginServiceRequestDetails(email, password);
            const loginResponse = await performAction(url, options);
            saveloginInfoToLocal(loginResponse);
            const userDetails = getLoggedInUserInfo();
            const accessibleRoutes = getCurrentSessionPages();
            dispatch(userActions.setAuthInfo(userDetails));
            dispatch(userActions.setAccsibleRoutes(accessibleRoutes));
            navigate("/");
        }
        catch (e) {
            console.error('error logging in user', e);
        }
    }
    const fetchCurrentUserDetails = useCallback(async (id) => {
        try {

            const { url, options } = getResourcePayload(id);
            const resourceDetails = await performAction(url, options);
            if (typeof resourceDetails === "object" && resourceDetails.Result) {
                const { AccountType, Address, CreatedOn, Email, Phone, ResourceName, Status } = resourceDetails.Result;
                const fetchedUserInfo = {
                    resourceName: ResourceName,
                    resourceType: AccountType,
                    resourceId: id,
                    resourceEmail: Email,
                    resourcePhoneNumber: Phone,
                    resourceCreatedOn: moment(new Date(CreatedOn)).format(DATE_TIME_FORMAT.DISPLAY),
                    resourceLocation: Address,
                    resourceStatus: Status
                }
                return fetchedUserInfo;
            }

            return null;

        }
        catch (e) {
            console.error('Error fetching current user details');
            return null;
        }
    }, [performAction])
    const logoutUser = () => {
        clearCurrentSession();
        dispatch(userActions.resetUserInfo());
        navigate(SITE_LINKS_SCHEMA.LOGIN, { replace: true })
    }
    const resetPassword = async (resetPasswordFormValues) => {
        try {
            const { options, url } = getResetPasswordServiceConfig(resetPasswordFormValues);
            return await performAction(url, options);
        }
        catch (e) {
            console.error("Error re setting the password");
        }
    }
    const requestTemporaryPassword = async ({ email }) => {
        try {
            const { url, options } = getForgotPasswordRequestConfig(email);
            return await performAction(url, options)
        }
        catch (e) {
            console.error("unable to request secret token")
        }
    }
    const changePassword = async(currentPass,newPass)=>{
        try{
            const {url,options} = getChangePasswordServiceConfig(currentPass,newPass);
            return await performAction(url,options)
        }
        catch(e){   
            console.error('Error changing password');
        }
    }
    return {
        isLoading,
        isError,
        loginUser,
        logoutUser,
        fetchCurrentUserDetails,
        resetPassword,
        requestTemporaryPassword,
        changePassword
    }
}